/*
  Plan-limit responses are converted to localized client copy while ordinary
  throttling and operational failures retain their original message.
*/
import { ApiRequestError, isQuotaError } from "./client";

export interface PlanErrorStrings {
  quota: string;
  forbidden: string;
  fallback: string;
}

export interface PlanErrorPresentation {
  message: string;
  showUpgrade: boolean;
}

export function resolvePlanAwareError(
  error: unknown,
  strings: PlanErrorStrings
): PlanErrorPresentation {
  if (isQuotaError(error)) {
    const message =
      error instanceof ApiRequestError && error.code === "SERVICE_QUOTA_EXCEEDED"
        ? strings.quota
        : strings.forbidden;
    return { message, showUpgrade: true };
  }
  return {
    message: error instanceof Error ? error.message : strings.fallback,
    showUpgrade: false,
  };
}
